import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Address } from '../interface/address';
import { AddressRequest, OrderLineItem, OrderPayment, OrderShipping } from '../interface/untouched-order-request';

@Injectable()
export class OrderMapperService {


    /**
     * @description map modified shipping details
     * @date 2019-05-03
     * @param {*} response
     * @memberof OrderEditComponent
     */
    mapModifiedOrderShippingDetails(orderFormGroup: FormGroup): OrderShipping[] {
        const orderShippingMapper: OrderShipping[] = [];
        if (orderFormGroup && orderFormGroup.value) {
            const orderShippingDetails = {
                deliveryPreferenceId: orderFormGroup.value.deliveryPreference,
                shipMethodId: +orderFormGroup.value.shipMethodId
            };
            orderShippingMapper.push(orderShippingDetails);
        }
        return orderShippingMapper;
    }

    /**
     * @description map the address details information
     * @date 2019-05-03
     * @param {*} response
     * @memberof OrderEditComponent
     */
    mapAddressDetails(address: Address[]): AddressRequest[] {
        const addresses: AddressRequest[] = [];
        if (address && address.length > 0) {
            address.forEach(x => {
                const addressDetail: AddressRequest = {
                    firstName: x.firstName ? x.firstName : null,
                    middleName: x.middleName ? x.middleName : null,
                    lastName: x.lastName ? x.lastName : null,
                    phoneType: x.phoneType ? x.phoneType : null,
                    addressLine1: x.addressLine1 ? x.addressLine1 : null,
                    addressLine2: x.addressLine2 ? x.addressLine2 : null,
                    city: x.city ? x.city : null,
                    stateId: x.stateId,
                    countryId: x.countryId,
                    postalCode: x.postalCode ? x.postalCode : null,
                    addressType: x.addressType ? x.addressType : null,
                    phone: x.phone ? x.phone : null,
                    addressVerified: x.addressVerified ? x.addressVerified : false
                };
                addresses.push(addressDetail);
            });

        }
        return addresses;
    }

    /**
     * @description map the order line items
     * @date 2019-05-03
     * @param {*} response
     * @memberof OrderEditComponent
     */
    mapOrderLineItems(orderLineItems: OrderLineItem[], isModified?: boolean): OrderLineItem[] {
        const orderLineItemsMapper: OrderLineItem[] = [];
        if (orderLineItems && orderLineItems.length > 0) {
            orderLineItems.forEach(x => {
                const orderLineItem = {
                    productId: isModified ? x.id : x.productId,
                    quantity: +x.quantity
                };
                orderLineItemsMapper.push(orderLineItem);
            });
        }
        return orderLineItemsMapper;
    }

    /**
     * @description map the shipping details
     * @date 2019-05-03
     * @param {*} response
     * @memberof OrderEditComponent
     */
    mapOrderShippingDetails(orderShipping: OrderShipping[]): OrderShipping[] {
        const orderShippingMapper: OrderShipping[] = [];
        if (orderShipping && orderShipping.length > 0) {
            orderShipping.forEach(x => {
                const orderShippingDetails = {
                    deliveryPreferenceId: x.deliveryPreferenceId,
                    shipMethodId: x.shipMethodId
                };
                orderShippingMapper.push(orderShippingDetails);
            });
        }
        return orderShippingMapper;
    }

    /**
     * @description map the order payment details
     * @date 2019-05-03
     * @param {*} response
     * @memberof OrderEditComponent
     */
    mapOrderPaymentDetails(orderPayment: OrderPayment[]): OrderPayment[] {
        const orderPaymentsMapper: OrderPayment[] = [];
        if (orderPayment && orderPayment.length > 0) {
            orderPayment.forEach(x => {
                const orderLineItem = {
                    paymentMode: x.paymentMode,
                    isPaymentChanged: false
                };
                orderPaymentsMapper.push(orderLineItem);
            });
        }
        return orderPaymentsMapper;
    }

}



// WEBPACK FOOTER //
// ./src/app/customerservice/services/order-mapper.service.ts